import axios from 'axios';
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import * as Yup from "yup";
import Cookies from "js-cookie";
import { adminMainUrl } from '../../../../Config';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getOrganisationAgentList } from '../../../../Redux/action/Organisation/OrganisationListAction';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Table } from "antd";

const IATAAgentAdd = ({ accessedPermission }) => {
    const navigate = useNavigate();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const [activeTab, setActiveTab] = useState("iata_agent");

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');

    useEffect(() => {
        if (token && user_id) {
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token]);





    const initialValues = {
        name: "",
        iata_code: "",
        tds_rate: "",
        tds_remark: "",
        pan_number: "",
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            // name: Yup.string().required("Please enter name")
        }),
        onSubmit: (values, { resetForm }) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }
                axios.post(`${adminMainUrl}/api/iata-agent/create`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            navigate(`/flexichain/iata-agent/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    const columns = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: "Default", dataIndex: "is_default", key: "is_default" },
        { title: "Address 1", dataIndex: "address_one", key: "address_one" },
        { title: "Address 2", dataIndex: "address_two", key: "address_two" },
        { title: "City", dataIndex: "city", key: "city" },
        { title: "State", dataIndex: "state", key: "state" },
        { title: "Country", dataIndex: "country", key: "country" },
        { title: "Pin Code", dataIndex: "pincode", key: "pincode" },
        { title: "Contact Person", dataIndex: "contact_person_name", key: "contact_person_name" },
        { title: "Mobile No.", dataIndex: "mobile_no", key: "mobile_no" },
        { title: "GST State Name", dataIndex: "gst_state_name", key: "gst_state_name" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];
    const [dataSource, setDataSourcer] = useState(false);

    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <h4>Add IATA Agent</h4>
                    </div>
                    <div className="row-gap-2">
                        <div className="tab-content" id="pills-tabContent">
                            <Tabs
                                activeKey={activeTab} // Controlled by state
                                onSelect={(k) => setActiveTab(k)} // Update state on tab change
                                transition={false}
                                id="noanim-tab-example"
                                className="nav nav-pills mb-3 custom-tabs gap-0"
                            >
                                <Tab eventKey="iata_agent" title="IATA Agent" className="nav-item" disabled={false}>
                                    <div className="card">
                                        <div className="card-body">
                                            {/* Filter */}
                                            <form onSubmit={formik.handleSubmit} >
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label htmlFor="name" className='form-label mb-0'>
                                                            Name
                                                        </label>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            id="name"
                                                            name='name'
                                                            value={formik.values.name}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            maxLength={250}
                                                        />

                                                    </div>
                                                    <div className="col-md-6">
                                                        <label htmlFor="iata_code" className='form-label mb-0'>
                                                            IATA Code
                                                        </label>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            id="iata_code"
                                                            name='iata_code'
                                                            value={formik.values.iata_code}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            maxLength={5}
                                                        />

                                                    </div>
                                                    <div className="col-md-6">
                                                        <label htmlFor="tds_rate" className='form-label mb-0'>
                                                            TDS Rate
                                                        </label>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            id="tds_rate"
                                                            name='tds_rate'
                                                            value={formik.values.tds_rate}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            maxLength={250}
                                                        />

                                                    </div>
                                                    <div className="col-md-6">
                                                        <label htmlFor="tds_remark" className='form-label mb-0'>
                                                            TDS Remarks
                                                        </label>
                                                        <textarea
                                                            className="form-control"
                                                            id="tds_remark"
                                                            name='tds_remark'
                                                            value={formik.values.tds_remark}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        ></textarea>

                                                    </div>
                                                    <div className="col-md-6">
                                                        <label htmlFor="pan_number" className='form-label mb-0'>
                                                            PAN Number
                                                        </label>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            id="pan_number"
                                                            name='pan_number'
                                                            value={formik.values.pan_number}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            maxLength={10}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row d-flex justify-content-end">
                                                    <div className="col-md-6 d-flex justify-content-end">
                                                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Save and Next"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <div className='card-body'>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <h4>Address</h4>
                                                </div>
                                                <div className="col-md-6 text-end">
                                                    <button type='button' className="btn btn-sm btn-primary" title="Add IATA Agent details to save address." onClick={() => { toast.error("Add IATA Agent details to save address.") }}>
                                                        + Add Address
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="table-responsive custom-table query-list-table">
                                                <Table className="table datanew dataTable no-footer"
                                                    dataSource={dataSource}
                                                    columns={columns}
                                                    pagination={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="contact_details" title="Contact Details" className="nav-item" disabled={true} >
                                    {/* <CustomsTab token={token} user_id={user_id} /> */}
                                </Tab>
                            </Tabs>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default IATAAgentAdd